import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import includes from 'lodash/includes'

import i18n from 'modules/core/lib/i18n'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import Item from './Item'

const BlankSlate = () => {
  return (
    <Box padding="s40" alignItems="center">
      <Text.Normal>{i18n.t('common.legal_entities_not_found')}</Text.Normal>
    </Box>
  )
}

interface ListProps {
  legalEntities: LegalEntity[]
  selectedIds: string[]
  onSelectLegalEntity: (legalGender: LegalEntity) => () => void
  onSelectMultiple: (...args: any[]) => any
}

export default function List({
  legalEntities,
  selectedIds,
  onSelectLegalEntity,
  onSelectMultiple,
}: ListProps) {
  if (!legalEntities.length) return <BlankSlate />

  return (
    <>
      {legalEntities.map((legalEntity) => (
        <Item
          key={legalEntity.attributes.id}
          onSelectMultiple={onSelectMultiple}
          onSelectLegalEntity={onSelectLegalEntity}
          selected={includes(selectedIds, legalEntity.attributes.id)}
          legalEntity={legalEntity}
        />
      ))}
    </>
  )
}
